import { useState } from 'react';
import { Head, Link, router } from '@inertiajs/react';
import { MainLayout } from '../../layouts/MainLayout';
import { route } from '../../utils/route';

interface Props {
  email: string;
  unsubscribed: boolean;
}

// Unsubscribe link of marketing emails. The URL is signed for this address,
// so the page posts back to itself.
export default function Unsubscribe({ email, unsubscribed }: Props) {
  const [processing, setProcessing] = useState(false);

  const submit = (action: 'unsubscribe' | 'resubscribe') => {
    router.post(
      window.location.href,
      { action },
      {
        preserveScroll: true,
        onStart: () => setProcessing(true),
        onFinish: () => setProcessing(false),
      },
    );
  };

  return (
    <MainLayout>
      <Head>
        <title>Suscripción por email | Abasto Virtual</title>
        <meta name="robots" content="noindex" />
      </Head>

      <div className="min-h-screen bg-slate-50 pb-16 pt-10 md:pt-16">
        <div className="mx-auto max-w-[500px] px-4">
          <div className="mt-6 rounded-2xl bg-white p-8 text-center shadow-lg md:p-10">
            {unsubscribed ? (
              <>
                <h1 className="mb-3 text-2xl font-bold text-gray-800">Listo, te diste de baja</h1>
                <p className="mb-2 text-base leading-relaxed text-gray-600">
                  No te vamos a mandar más promociones ni novedades a <strong>{email}</strong>.
                </p>
                <p className="mb-8 text-sm text-gray-500">
                  Los mails de tus pedidos, pagos y facturas te van a seguir llegando.
                </p>
                <button
                  type="button"
                  disabled={processing}
                  onClick={() => submit('resubscribe')}
                  className="inline-flex w-full items-center justify-center rounded-xl border border-gray-300 bg-white px-7 py-3.5 text-base font-semibold text-gray-700 transition-colors hover:bg-gray-50 disabled:opacity-60"
                >
                  Me arrepentí, quiero seguir recibiéndolas
                </button>
              </>
            ) : (
              <>
                <h1 className="mb-3 text-2xl font-bold text-gray-800">¿Dejás de recibir nuestras promociones?</h1>
                <p className="mb-8 text-base leading-relaxed text-gray-600">
                  Vamos a dejar de mandarle ofertas y novedades a <strong>{email}</strong>. Los mails de tus pedidos,
                  pagos y facturas te van a seguir llegando.
                </p>
                <button
                  type="button"
                  disabled={processing}
                  onClick={() => submit('unsubscribe')}
                  className="inline-flex w-full items-center justify-center rounded-xl bg-red-600 px-7 py-3.5 text-base font-semibold text-white transition-colors hover:bg-red-700 disabled:opacity-60"
                >
                  Darme de baja
                </button>
              </>
            )}

            <Link
              href={route('products.index')}
              className="mt-4 inline-flex w-full items-center justify-center rounded-xl px-7 py-3 text-sm font-medium text-gray-500 hover:text-gray-700 hover:no-underline"
            >
              Ir a la tienda
            </Link>
          </div>
        </div>
      </div>
    </MainLayout>
  );
}
